<form
  [formGroup]="purchaseOrderForm"
  #purchaseOrderFormElement
  (ngSubmit)="nativeSubmit()"
>
  <!-- Start::title -->
  <div class="field mb-4">
    <span class="text-900 text-2xl block font-semibold mb-5"
      >Adjunta tu orden de compra</span
    >
  </div>
  <!-- End::title -->

  <!-- Start::input código -->
  <div class="field mb-4 flex flex-column">
    <label for="code" class="font-semibold text-900"
      >N° de orden de compra</label
    >
    <input
      id="code"
      type="text"
      pInputText
      maxlength="18"
      spellcheck="false"
      formControlName="code"
    />
  </div>
  <!-- End::input código -->

  <!-- Start::input centro de costo -->
  <!-- <div class="field mb-4 flex flex-column" (click)="sidebar.show()">
    <label for="code" class="font-semibold text-900">Centro de costo</label>
    <div
      class="flex p-4 border-round border-1 border-primary bg-blue-50 w-full cursor-pointer flex align-items-center h-6rem"
    >
      <div class="flex flex-column gap-1">
        <div
          class="font-semibold"
          [ngClass]="{ uppercase: selectedCostCenter() }"
        >
          {{
            selectedCostCenter()
              ? selectedCostCenter()?.name
              : 'Puedes agregar un centro de costo'
          }}
        </div>
        <span class="text-sm">
          {{
            selectedCostCenter()
              ? selectedCostCenter()?.code
              : 'Este campo es opcional'
          }}
        </span>
      </div>
      <i class="fa-sharp fa-solid fa-angle-right text-xl ml-auto"></i>
    </div>
  </div> -->
  <!-- End::input centro de costo -->

  <!-- Start::input de archivo -->
  @if(!session?.creditLine?.requiresConfirmation){
  <div class="field mb-4 flex flex-column">
    <label for="file" class="font-semibold text-900 mb-1"
      >Orden de compra</label
    >
    <app-file-upload-input formControlName="file" />
  </div>
  }
  <!-- End::input de archivo -->
</form>

<app-cost-center-sidebar
  #sidebar
  (onSubmit)="onSelectCostCenter($event)"
  [selectedCostCenterCode]="selectedCostCenter()?.code || null"
/>
